import AppConstants from '../constants/AppConstants';
import FormattedStaff from '../models/FormattedStaff';
import { PayRateReq, StaffReq } from '../proxy/proxy';
import { AxiosPayRatesClient, AxiosStaffClient } from '../proxy/ProxyClients';

// const api = new Client(AppConstants.BASE_API_URL, AxiosStaffClient);

const StaffService = {
  getAllStaffs: () => AxiosStaffClient.all()
    .then((resp) => {
      const result = (resp || []).filter((staff: any) => !staff.isSoftDeleted);
      return result.map((staff: any) => new FormattedStaff(staff));
    }),
  getStaffById: (id: number) => AxiosStaffClient.get(id)
    .then((resp) => new FormattedStaff(resp)),
  inviteStaff: (data: StaffReq) => AxiosStaffClient.invite(data),
  updateStaff: (id: number, data: StaffReq) => AxiosStaffClient.update(id, data),
  getStaffPayRatesById: (id: number) => AxiosPayRatesClient.getPayRate(id),
  updatePayRates: (staffIds: Array<number>, payRateReq: PayRateReq) => AxiosPayRatesClient.updatePayRates({ staffIds, payRateReq }),
  deleteStaff: (id: number = 0) => AxiosStaffClient.delete(id),
  checkGST: (id: number = 0) => AxiosStaffClient.updateGST(id)
    .then((resp) => new FormattedStaff(resp))
};

export default StaffService;
